var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Views == null) {
  InlineVariations.Views = {};
}

InlineVariations.Views.Trait = Backbone.View.extend({
  dropdownSelection: '.inline-variation-dropdown-selection',
  traitValues: '.inline-variation-trait-value',
  inlineTitleHtml: '.inline-variation-trait-title',
  body: 'body',
  touch: {
    main: '.t-main',
    traitValuesContainer: '.inline-variation-trait-values'
  },
  events: {
    'click .inline-variation-dropdown-selection': 'toggleDropdown',
    'click .inline-variation-trait-value': 'traitValueSelection'
  },
  webSwatchEvents: {
    'mouseenter .inline-variation-trait-value': 'updateTitleToHoveredTrait',
    'mouseleave .inline-variation-trait-value': 'updateTitleToOriginalTrait'
  },
  initialize: function() {
    this.layout = this.model.get('layout');
    this.title = this.model.get('title');
    this.isSwatchImageDropdown = this.layout.isImageSwatch && this.layout.isDropdown;
    this.isTouch = this.options.isTouch;
    this.$body = $(this.body);
    this.$traitValues = this.$el.find(this.traitValues);
    if (this.layout.isDropdown) {
      this.placeholderHtml = this.model.get('title');
      this.placeholderValue = this.model.get('placeholderValue');
      this.placeholderValueId = this.model.get('placeholderValueId');
      this.$titleHtml = this.$el.find(this.dropdownSelection);
    } else {
      this.$titleHtml = this.$el.find(this.inlineTitleHtml);
    }
    if (this.layout.enableFilterSheet) {
      this.$body = $(this.touch.main);
      this.$touchTraitValuesContainer = this.$el.find(this.touch.traitValuesContainer);
      this.$touchIVTraitsContainer = this.$el.parent();
    }
    this.listenTo(this.model, 'change:selectedTraitValue', this.setTraitValue);
    if (this.layout.isSwatch && !(this.isTouch || this.isTouchDevice())) {
      _.extend(this.events, this.webSwatchEvents);
    }
    if (this.isTouch || this.isTouchDevice()) {
      this.removeHoverClass();
    }
    return this.processTraitValues();
  },
  removeHoverClass: function() {
    return this.$traitValues.removeClass('ch-bdr-prim');
  },
  isTouchDevice: function() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  },
  processTraitValues: function() {
    var i, len, ref, results, value;
    ref = this.model.get('values');
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      value = ref[i];
      results.push(value.$el = this.$el.find("#" + value.id));
    }
    return results;
  },
  toggleDropdown: function(e) {
    var isOpen;
    isOpen = this.$el.hasClass('open');
    if (!this.layout.enableFilterSheet) {
      this.model.collection.closeDropdowns();
    }
    if (this.layout.enableFilterSheet && this.$body.hasClass('inline-variation-backdrop')) {
      this.closeDropdown();
    }
    if (isOpen) {
      return;
    }
    this.model.collection.view.showBackdrop(this);
    if (!this.layout.enableFilterSheet) {
      return this.openTrait();
    }
  },
  slideDownAnimation: function(isFilterSheetOpen) {
    var delay, showScrollAnimation;
    showScrollAnimation = this.model.get('index') && isFilterSheetOpen && this.layout.enableFilterSheet;
    delay = showScrollAnimation ? 10 : 400;
    return this.$touchTraitValuesContainer.slideDown(delay, (function(_this) {
      return function() {
        _this.openTrait();
        if (showScrollAnimation) {
          return _this.$touchIVTraitsContainer.animate({
            scrollTop: _this.$el.position().top + _this.$touchIVTraitsContainer.scrollTop() - 51
          }, 400);
        }
      };
    })(this));
  },
  openTrait: function() {
    this.$el.addClass('open');
    return this.sendDropdownTrackingEvent(false);
  },
  sendDropdownTrackingEvent: function(isOpen) {
    var status;
    status = isOpen ? 'close' : 'open';
    return OptimizeSuite.TrackingHub.add("inline-variations-dropdown-" + status);
  },
  closeDropdown: function() {
    var isOpen;
    if (this.layout.enableFilterSheet) {
      this.$body.addClass('stop-propagation');
    }
    if (!(isOpen = this.$el.hasClass('open'))) {
      return;
    }
    if (this.layout.enableFilterSheet) {
      return this.$touchTraitValuesContainer.slideUp(400, (function(_this) {
        return function() {
          _this.$el.removeClass('open');
          return _this.sendDropdownTrackingEvent(isOpen);
        };
      })(this));
    } else {
      this.$el.removeClass('open');
      return this.sendDropdownTrackingEvent(isOpen);
    }
  },
  traitValueSelection: function(e) {
    var $target, selected;
    $target = $(e.currentTarget);
    if ($target.hasClass('sold-out')) {
      return e.stopPropagation();
    }
    if (this.layout.enableFilterSheet) {
      this.$body.addClass('stop-propagation');
    }
    selected = $target.hasClass('selected');
    if (selected && this.layout.isDropdown && !(this.layout.isSwatch || this.isTouch)) {
      return;
    }
    this.$traitValues.removeClass('selected');
    if (selected) {
      this.model.setSelectedTraitValueById();
    } else {
      this.model.setSelectedTraitValueById($target.attr('id'));
    }
    return this.model.collection.view.render();
  },
  updateTitleToHoveredTrait: function(e) {
    var $target, currentTraitValue;
    if (!this.layout.isSwatch) {
      return;
    }
    $target = $(e.currentTarget);
    if ($target.hasClass('sold-out')) {
      return;
    }
    if (currentTraitValue = this.model.getTraitValueById($target.attr('id'))) {
      return this.$titleHtml.html(currentTraitValue.selectedHtml);
    }
  },
  updateTitleToOriginalTrait: function(e) {
    if (!this.layout.isSwatch) {
      return;
    }
    if ($(e.currentTarget).hasClass('sold-out')) {
      return;
    }
    return this.$titleHtml.html(this.model.get('selectedTraitValueHtml') || this.title);
  },
  setTraitValue: function() {
    var selectedTraitValue, selectedTraitValueId;
    if (!this.layout.enableFilterSheet) {
      this.closeDropdown();
    }
    selectedTraitValue = this.model.get('selectedTraitValueHtml');
    selectedTraitValueId = this.model.get('selectedTraitValueId');
    if (this.layout.isDropdown || this.layout.isSwatch) {
      if (!selectedTraitValue) {
        if (this.layout.isSwatch) {
          selectedTraitValue = this.title;
        } else {
          selectedTraitValue = this.placeholderHtml;
          selectedTraitValueId = this.placeholderValueId;
        }
      }
      this.$titleHtml.html(selectedTraitValue);
    }
    return this.$traitValues.each((function(_this) {
      return function(index, traitValue) {
        if (_this.layout.isSwatch || !_this.layout.isDropdown) {
          return $(traitValue).toggleClass('selected c-txt-prim c-bdr-prim', $(traitValue).attr('id') === selectedTraitValueId);
        } else {
          return $(traitValue).toggleClass('selected c-txt-prim', $(traitValue).attr('id') === selectedTraitValueId);
        }
      };
    })(this));
  },
  showErrorMessages: function() {
    var ref;
    if (!this.model.get('selectedTraitValue')) {
      this.$el.addClass('error');
    }
    return (ref = this.$traitValuesContainer) != null ? ref.addClass('error') : void 0;
  },
  hideErrorMessages: function() {
    var ref;
    this.$el.removeClass('error');
    return (ref = this.$traitValuesContainer) != null ? ref.removeClass('error') : void 0;
  },
  toggleSoldOut: function(traitValue, isSoldOut) {
    traitValue.$el.toggleClass('sold-out', isSoldOut);
    if (!(this.isTouch || this.isTouchDevice())) {
      return traitValue.$el.toggleClass('ch-bdr-prim', !isSoldOut);
    }
  }
});

module.exports = InlineVariations.Views.Trait;

//# sourceMappingURL=data:application/json;base64,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
